import { useEffect, useRef } from 'react';
import { hydrateShellState } from './shellSlice';
import { useAppDispatch, useAppSelector } from './hooks';
import { readShellState, resolveShellStorageKey, writeShellState } from './shellStorage';

export const useShellPersistence = (userSub?: string | null) => {
  const dispatch = useAppDispatch();
  const shellState = useAppSelector((state) => state.shell);
  const hydratedRef = useRef(false);
  const storageKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const key = resolveShellStorageKey(userSub ?? null);
    storageKeyRef.current = key;
    hydratedRef.current = false;
    const stored = readShellState(key);
    if (stored) {
      dispatch(hydrateShellState(stored));
    }
    hydratedRef.current = true;
  }, [dispatch, userSub]);

  useEffect(() => {
    if (!hydratedRef.current) return;
    const key = storageKeyRef.current;
    if (!key) return;
    writeShellState(key, shellState);
  }, [shellState]);

  // NOTE: Cross-tab sync intentionally disabled. Add a storage listener here if needed.
};
